<template>
	<div>
		<el-row >
    	<Breadcrumb :route="this.$route"></Breadcrumb>

    	<!-- action -->
    	<el-col :xs="8" :sm="8" :lg="8">
	      <el-button type="normal" @click.prevent="goBack" class="ml-20" circle>
	        <i class="el-icon-d-arrow-left"></i>
	      </el-button>
	    </el-col>
	    <el-col :xs="16" :sm="16" :lg="16" class="text-right">
	      <el-button v-if="job.jobInfo.alreadySigned === 'no'" type="primary" @click.prevent="handleSign" class="mr-20">簽核 <i
	          class="el-icon-s-claim"></i></el-button>
	      <el-tag v-if="job.jobInfo.alreadySigned === 'yes'" type="warning" class="mr-20">已簽核</el-tag>
	    </el-col>
    </el-row>

    <!--    基本資料-->
    <el-row>
	    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
	      <el-main>
	        <el-card class="box-card">
	          <div slot="header" class="clearfix">
	            <span>基本資料</span>
	          </div>
	          <div>
	            <el-form class="myform">
	                <el-row>
		                <el-col :xs="24" :sm="24" :md="8">
		                  <p>填單人: {{job.todoInfo.userObj.username}} </p>
		                </el-col>
		                <el-col :xs="24" :sm="24" :md="8">
		                	<p class="mt-10">報表日期: {{job.todoInfo.startDate | fmtDate}}</p>
		                </el-col>
		                <el-col :xs="24" :sm="24" :md="8">
		                  <p class="mt-10">標題: {{job.todoInfo.title}}</p>
		                </el-col>
		              </el-row>
		              <el-row>
		                <el-col :xs="24" :sm="24" :md="8">
		                	<p class="mt-10">申請單編號: {{job.todoInfo.reqPayNo}} </p>
		                </el-col>
		                <el-col :xs="24" :sm="24" :md="8">

                      

		                	<p class="mt-10">關聯日報: 
                        <router-link target="_blank" :to="`${job.todoInfo.relatedTodo.todoUrl}${job.todoInfo.relatedTodo.id}?from=req_miles_statistic`">
                          {{job.todoInfo.relatedTodo.startDate | fmtDate }} {{job.todoInfo.relatedTodo.title}} 
                      </router-link>  
                      
                      </p>
		                </el-col>
		              </el-row>

	            </el-form>
	          </div>
	        </el-card>
	      </el-main>
	    </el-col>
	  </el-row>

	  <el-row>
	  	
      <el-col :xs="24" :sm="24" :lg="24">
        <el-main class="taskMain">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>交通工具與里程數</span>
            </div>
            <div>
              <el-table :data="job.drivingHistory" empty-text="無資料" stripe  :default-expand-all="true">
                <el-table-column label="項次" width="50">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
                </el-table-column>
                <el-table-column label="交通工具" prop="carType">
                </el-table-column>
                <el-table-column label="" type="expand" >
                  <template slot-scope="scope">
                    <div v-if="scope.row.distance > 0" >
                      <p class="mt-10 ml-10">
                        起: {{scope.row.startAddress}}<br>
                        迄: {{scope.row.endAddress}}
                      </p>
                      <p class="mt-10 ml-10">
                        哩程: {{scope.row.distance}} 公里
                      </p>
                    </div>
                    
                  </template>
                </el-table-column>
              </el-table>
              <el-row class="mt-10 mb-10 pl-20 pr-20"> 
                <el-col :xs="24" :sm="24" :lg="24">
                  <div class="text-right">總計公里數 : {{totalKm}} 公里</div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-main>
      </el-col>
	  </el-row>

    <el-row>
      <!--    簽核紀錄-->
      <el-col :xs="24" :sm="24" :lg="24" v-if="job.jobInfo.status !== 'draft'" class="mt-20">
        <el-main class="taskMain">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>簽核紀錄</span>
            </div>
            <div>
              

              <el-table :data="job.signoffHistory" empty-text="無資料" stripe :default-expand-all="true">
                <el-table-column label="時間" prop="updatedAt" width="170">
                  <template slot-scope="scope">
                    <p>簽核時間 :</p>
                    <p>{{ scope.row.updatedAt | fmtDateTime }}</p>
                    <p class="mt-10">{{ scope.row.signerObj.username }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="結果" prop="signResult">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.signResult === 'N'" type="danger">{{ scope.row.signResult | signResult }}</el-tag>
                    <el-tag v-else>{{ scope.row.signResult | signResult }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="" type="expand" width="30">
                    <template slot-scope="scope">
                      <p class="mt-10 ml-10">簽核備註 : {{ scope.row.notes }}</p>
                    </template>
                  </el-table-column>

                  <el-table-column>
                  </el-table-column>
              </el-table>

            </div>
          </el-card>
        </el-main>
      </el-col>
    </el-row>


	  <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
    <el-dialog title="簽核資訊"
               :visible.sync="signoff.dialog"
               :width="dw">

      <el-form :model="job.jobInfo" ref="signForm" :rules="signoff.rules">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="簽核選擇" prop="signResult">
              <el-radio v-model="job.jobInfo.signResult" label="Y">同意</el-radio>
              <el-radio v-model="job.jobInfo.signResult" label="N">退回</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="備註" prop="notes">
              <el-input rows="5" type="textarea" v-model="job.jobInfo.notes" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="signoff.dialog = false">取 消</el-button>
        <el-button type="primary" @click="sendSignoff('signForm')">確 定</el-button>
      </div>
    </el-dialog>

	</div>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'

export default {
	name: 'ReqMilesReviewPage',
	components:{
		Breadcrumb
	},
	data(){
		let checkName = (rule, value, callback) => {
      if (value === '' || value === null) {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }
    let checkRadio = (rule, value, callback) => {
      console.log("checkRadio:", rule, value)
      if (value === '' || value === null) {
        callback(new Error('請選擇同意或退回'))
      } else {
        callback()
      }
    }
  	return {
  		dw: '50%',
      signoff:{
        dialog: false,
        notes: '',
        rules: {
          signResult: [{required: true, validator: checkRadio, trigger: 'change'}]
        }
      },
      job:{
        id:'',
        jobInfo:{
          id:'',
          alreadySigned:'no'
        },
        todoInfo:{
          userObj:{},
          relatedTodo:{}
        },
        signoffHistory:[],
        drivingHistory:[]
      },
      totalKm: 0.0
  	}
	},
	methods:{
		setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "60%"
      }
    },
		handleSign() {
      this.signoff.dialog = true
      this.signoff.notes = ''
    },
    findJobContent() {
      this.request.get("/job/detail/" + this.job.id).then(res => {
        if (res.code === '200') {
          this.job = res.data

          let dh = this.job.drivingHistory
          let km = 0.0
          dh.forEach((element) => {
            if (element.startMile == 0) { //新版哩程計算方式
              km += element.distance
            } else { //舊版
              km += element.endMile - element.startMile
            }
          });
          this.totalKm = km.toFixed(1)

        }
      })
    },

		sendSignoff(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.request.post("/job", this.job.jobInfo).then(res => {
            if (res.code === '200') {
              this.showResult('success', '完成簽核')
              this.signoff.dialog = false
              this.$router.push('/message/my-signoff')
            } else {
              this.showResult('error', '簽核結果儲存失敗')
            }
          })
        }
      })
    },


		goBack() {
      this.$router.push('/message/my-signoff')
    },
	},
	mounted(){
		this.job.id = this.$route.params.jobId
    this.findJobContent()
    this.setDialogWidth();
	}
}

</script>

<style scoped>
	
</style>